import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { HiChevronRight } from 'react-icons/hi';
import './Breadcrumb.css';
import {Breadcrumb as FlowbiteBreadcrumb} from "flowbite-react";

export interface BreadcrumbItem {
  label: ReactNode;
  onClick?: () => void;
  link?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
  children?: ReactNode; // Support for actions on the right side
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className = '', children }) => {
  return (
    <nav className={`breadcrumb-container ${className}`} aria-label="Breadcrumb">
    <FlowbiteBreadcrumb>
          {items.map((item, index) => (
              <FlowbiteBreadcrumb.Item className="breadcrumb-content">
                {item.link ? (
                  <Link 
                    to={item.link} 
                    className="breadcrumb-link" 
                    onClick={item.onClick}
                  >
                    {item.label}
                  </Link>
                ) : item.onClick ? (
                  <button 
                    type="button" 
                    className="breadcrumb-button" 
                    onClick={item.onClick}
                  >
                    {item.label}
                  </button>
                ) : (
                  <span className="breadcrumb-text">{item.label}</span>
                )}
              </FlowbiteBreadcrumb.Item>
          ))}
    </FlowbiteBreadcrumb>
      {children && (
        <div className="flex items-center gap-3 ml-4">
          {children}
        </div>
      )}
    </nav>
  );
};

export default Breadcrumb;
